module.exports = __webpack_public_path__ + "static/media/merchanside_checkout_success.f70d21eb.png";